export const panel = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
  },
  header: {
    background: "transparent",
    color: "{typography.accordion.heading.color}",
    padding: "{padding.16}",
    borderColor: "{content.border.color}",
    borderWidth: "0 0 {border.width.1} 0",
    borderRadius: "0",
  },
  toggleableHeader: {
    padding: "{padding.16}",
  },
  title: {
    fontWeight: "{typography.table.heading.font.weight}",
  },
  content: {
    padding: "0",
  },
  footer: {
    padding: "{padding.16}",
  },
  extend: {
    ui: {
      root: {
        gap: "{gap.16}",
      },
      header: {
        gap: "{gap.8}",
      },
      title: {
        fontSize: "{typography.table.heading.font.size}",
        fontLeading: "{typography.table.heading.font.leading}",
      },
    },
  },
  css: ({ dt }: any): string => `
    :has(> p-panel + p-panel) {
      display: flex;
      flex-direction: column;
      gap: ${dt("panel.ui.gap")};
    }

    p-panel[toggler="header"] > .p-panel-toggleable > .p-panel-header {
      cursor: pointer;
    }

    .p-panel {
      overflow: hidden;
    }

    .p-panel-header {
      gap: ${dt("panel.ui.header.gap")};
    }

    .p-panel:not(.p-panel-expanded) > .p-panel-header {
      border-bottom: none;
    }

    .p-panel-icons:empty {
      display: none;
    }

    .p-panel-header:not(:has(.p-panel-title)) {
      padding: ${dt("panel.content.padding")};
    }

    .p-panel-title {
      font-size: ${dt("panel.ui.title.font.size")};
      line-height: ${dt("panel.ui.title.font.leading")};
    }

    .p-panel-header:has(.section-header) {
      /* background: ${dt("surface.bg-grey-contrast")}; */
      transition: filter 0.4s ease-in-out;
      transform-origin: top;
    }

    .section-flash .p-panel-header {
      filter: brightness(70%);
    }

    .dark .section-flash .p-panel-header {
      filter: brightness(150%);
    }
  `,
};
